
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      order: null,
      gridColumns: null,
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      // layout grid magic
      // creates a 12 column grid with 32px gutters - named lines
      const gutter = 32
      const containerWidth = this.$store.state.app.containerWidth
      // const calculateColumnWidth = containerWidth - (columnGap * templateColumns) // container width after subtracting gutters and columns
      // styles.gridTemplateColumns = `[full-start] minmax(32px,1fr) [container-start] 0 [container-left-start] minmax(auto,calc(${this.$store.state.app.containerWidth}px /2)) [container-left-end] 0 [container-right-start]minmax(auto,calc(${this.$store.state.app.containerWidth}px /2)) [container-right-end] 0 [container-end] minmax(32px,1fr) [full-end]`
      styles.gridTemplateColumns = this.$matchMedia('sm')
        ? `[full-start] minmax(${gutter}px, 1fr) repeat(12, [c-start] minmax(auto, calc(${containerWidth}px / 12)) [c-end]) minmax(${gutter}px, 1fr) [full-end]`
        : `[full-start] minmax(${gutter}px, 1fr) repeat(12, [c-start] minmax(0, 1fr) [c-end]) minmax(${gutter}px, 1fr) [full-end]`

      // styles.columnGap = `${columnGap}px`
      // console.log(this.blok.layout)
      // styles.gridTemplateAreas = this.getBreakpointValue(
      //   `lg-[${this.blok.layout}]`
      // )

      styles.padding = this.getBreakpointValue(this.blok.padding)

      return styles
    },
  },
}
